var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TableHeaderRow } from '@devexpress/dx-react-grid-bootstrap4';
import { IconSVG } from '../../../../IconSVG';
export const InfoHeaderContentFactory = ({ infoDOMAttributes, }) => (_a) => {
    var _b;
    var { children, column } = _a, restProps = __rest(_a, ["children", "column"]);
    return (React.createElement(TableHeaderRow.Content, Object.assign({ column: column }, restProps), infoDOMAttributes && ((_b = column === null || column === void 0 ? void 0 : column.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== 'name' ? (
    // using inline styles as moving to external css not working
    React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
        } },
        children,
        React.createElement("div", Object.assign({}, infoDOMAttributes, { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
            } }),
            React.createElement(IconSVG, { iconType: "Info" })))) : (children)));
};
//# sourceMappingURL=InfoHeaderContentFactory.js.map